import React, { useEffect } from "react";
import feather from "feather-icons";

const Roadmap = () => {
  useEffect(() => {
    setTimeout(() => feather.replace(), 200);
  }, []);

  const roadmap = [
    {
      quarter: "Q4 2025",
      color: "neonPink",
      icon: "code",
      status: "In Progress",
      phase: "Foundation Phase",
      items: [
        "Website development & smart contract audit",
        "Core team formation & strategic partnerships",
        "Initial community building on Discord & Telegram",
      ],
      side: "right",
    },
    {
      quarter: "Q1 2026",
      color: "neonBlue",
      icon: "users",
      status: "In Progress",
      phase: "Community Growth",
      items: [
        "Private sale for early supporters & advisors",
        "Public sale launch & token distribution",
        "First educational webinars & AMAs",
      ],
      side: "left",
    },
    {
      quarter: "Q2 2026",
      color: "neonPurple",
      icon: "trending-up",
      status: "Upcoming",
      phase: "Exchange Listings",
      items: [
        "DEX listing with locked liquidity",
        "CEX negotiations & first listings",
        "Marketing campaigns to expand reach",
      ],
      side: "right",
    },
    {
      quarter: "Q3 2026",
      color: "neonPink",
      icon: "book",
      status: "Upcoming",
      phase: "Educational Platform",
      items: [
        "Beta launch of learning management system",
        "First accredited courses available",
        "Partner program for content creators",
      ],
      side: "left",
    },
    {
      quarter: "Q4 2026",
      color: "neonBlue",
      icon: "shield",
      status: "Upcoming",
      phase: "DAO Governance",
      items: [
        "Full DAO launch with voting rights",
        "First community-funded initiatives",
        "Strategic partnerships announced",
      ],
      side: "right",
    },
  ];

  return (
    <div className="text-white min-h-screen container mx-auto px-4 py-16 max-w-6xl">
      {/* === Header === */}
      <div className="text-center mb-16">
        <h1 className="text-5xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-neonPink to-neonBlue">
          Project Roadmap
        </h1>
        <p className="text-xl max-w-3xl mx-auto text-gray-300">
          Our strategic plan to build the future of youth empowerment on
          blockchain.
        </p>
      </div>

      {/* === Timeline === */}
      <div className="relative">
        {/* Ligne verticale centrale */}
        <div className="absolute left-1/2 h-full w-1 bg-gradient-to-b from-neonPurple to-neonBlue -translate-x-1/2"></div>

        {/* Étapes */}
        <div className="space-y-16">
          {roadmap.map((phase, i) => (
            <div key={i} className="relative">
              {/* Point central */}
              <div
                className={`absolute left-1/2 -ml-4 w-8 h-8 rounded-full bg-${phase.color} border-4 border-darkBg flex items-center justify-center -translate-x-1/2 shadow-lg shadow-${phase.color}/40`}
              >
                <i data-feather={phase.icon} className="w-4 h-4"></i>
              </div>

              {/* Carte roadmap */}
              <div
                className={`${
                  phase.side === "right" ? "ml-auto" : "mr-auto"
                } w-5/12 px-6 py-6 bg-gray-900/80 backdrop-blur-lg rounded-xl border border-${phase.color}/40 shadow-md shadow-${phase.color}/10`}
              >
                <div className="flex justify-between items-center mb-2">
                  <span className={`text-${phase.color} font-bold`}>
                    {phase.quarter}
                  </span>
                  <span
                    className={`text-xs bg-${phase.color} text-white px-2 py-1 rounded`}
                  >
                    {phase.status}
                  </span>
                </div>
                <h3 className="text-xl font-bold mb-2">{phase.phase}</h3>
                <ul className="list-disc list-inside text-gray-300 space-y-1">
                  {phase.items.map((item, j) => (
                    <li key={j}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* === CTA section === */}
      <div className="text-center mt-20">
        <h2 className="text-3xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-neonPurple to-neonPink">
          The Future is Just Beginning
        </h2>
        <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
          Stay with us as we continue shaping the NEXORA ecosystem. Together, we
          build a future of innovation and empowerment.
        </p>
        <a
          href="/projects"
          className="inline-block px-8 py-3 bg-gradient-to-r from-neonPurple to-neonPink rounded-lg font-bold hover:opacity-90 transition-all"
        >
          Explore Our Projects
        </a>
      </div>
    </div>
  );
};

export default Roadmap;
